const REMOVE_LICENSE_MODAL = {
  TITLE: "Remove License",
  CONTENT:
    "Are you sure you want to remove this license from your account? This means you will no longer be able to work shifts in this state.",
};

export { REMOVE_LICENSE_MODAL };
